export default __webpack_public_path__ + "static/media/activity-3.975ea6d4.png";